module.exports = __webpack_public_path__ + "img/order-shippping-icon-black.a156edf3.svg";